export default [
  {
    name: 'Usuários',
    path: 'usuarios',
    component: () => import('@/views/usuarios/Index.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      manager: true,
      routeReleasedForLite: true,
      breadcrumb: [
        { name: 'Administração', path: '/administracao' },
        { name: 'Usuários' }
      ]
    }
  },
  {
    name: 'Usuários Editar',
    path: 'usuarios/edit/:id',
    component: () => import('@/views/usuarios/Edit.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      manager: true,
      routeReleasedForLite: true,
      breadcrumb: [
        { name: 'Administração', path: '/administracao' },
        { name: 'Usuários', path: '/administracao/usuarios' },
        { name: 'Editar' }
      ]
    },
  },
  {
    name: 'Usuários Adicionar',
    path: 'usuarios/edit',
    component: () => import('@/views/usuarios/Edit.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      manager: true,
      routeReleasedForLite: true,
      breadcrumb: [
        { name: 'Administração', path: '/administracao' },
        { name: 'Usuários', path: '/administracao/usuarios' },
        { name: 'Adicionar' }
      ]
    }
  }
]